// src/components/HeroSection.js
import React from 'react';
import '../styles/HeroSection.css';
import bikeShareImg from '../assets/bike-share.png';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-overlay">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className='htxt'>Why ride alone, when you can share a journey!?</h1>
            <p className="subtitle">"Share the Ride, Split the Cost!"</p>
          </div>
          <div className="hero-image">
            <img src={bikeShareImg} alt="Bike Share" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
